import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    divider: { width: '100%', marginTop: '16px' },

    cardsTitle: {
      fontSize: 14,
      color: palette.darkGray,
      marginBottom: 4,
      fontWeight: 550,
    },
    dashboardHeader: { marginTop: 16 },
    dashboardButtonsHeader: {
      color: palette.blue,
      padding: '4px 8px!important',
      '&:hover': {
        backgroundColor: palette.superLightDeepBlue,
      },
    },
  });
